<template>
    <div class="flex flex-col">
        <label :for="idAttr" class="pb-3 uppercase text-base font-medium">{{ label }}</label>
        <input
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            :type="type"
            :placeholder="placeholder"
            :id="idAttr"
            :name="idAttr"
            class="input"
        >
        <p v-if="text" class="pt-2 text-sm">{{ text }}</p>
        <p v-if="error.length" class="text-red-500 text-sm mt-3 italic">{{ error[0] }}</p>
    </div>
</template>


<script>
export default {
    props: {
        label: {
            type: String
        },
        idAttr: {
            required: true,
            type: String
        },
        text: {
            type: String
        },
        error: {
            type: Array,
            default: []
        },
        type: {
            default: 'text'
        },
        placeholder: {
            type: String
        },
        modelValue: {
            required: true
        }
    },
    emits: ['update:modelValue'],
}
</script>

<style lang="scss" scoped>
</style>
